<template>
	<div :id="blok._uid" class="mx-sm py-xl md:mx-md lg:mx-0">
		<p
			class="mb-10 text-center font-prenton-cond text-5xl font-bold uppercase lg:text-8xl"
		>
			Avoimet työpaikat
		</p>

		<div class="flex flex-col">
			<div
				v-for="(job, index) in data?.jobs"
				:key="job.id"
				class="flex w-full flex-col"
			>
				<div class="flex flex-row justify-between py-5">
					<div class="flex flex-col">
						<p class="my-auto mb-sm font-prenton-cond text-xl md:text-3xl">
							{{ job.name.split(",")[0] }}
						</p>

						<p class="my-auto">{{ job.name.split(",")[1] }}</p>
					</div>

					<div class="flex flex-row">
						<p v-show="job.duedate">Hakuaika päättyy: {{ job.duedate }}</p>

						<nuxt-link
							:to="job.link"
							class="my-auto inline-block rounded bg-black p-sm"
						>
							<p
								class="font-prenton-cond text-xs text-white uppercase md:text-base md:leading-5"
							>
								Hae paikkaa
							</p>
						</nuxt-link>
					</div>
				</div>

				<div
					v-show="index + 1 !== data?.jobs.length"
					class="my-sm border-b"
				></div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import type {BlokComponent, OpenJobData} from "@pkg/shared/types";

const properties = defineProps<{
	blok: Extract<BlokComponent, {component: "sb-open-jobs"}>;
}>();

const data = ref<OpenJobData>();
const updated = ref("");
const error = ref("");

const jobsUri = properties.blok.jobs_uri;

async function fetchJobs() {
	const response = await fetch(jobsUri); // linkki storyblokista
	const jobs = await response.json();

	if (response.ok) {
		updated.value = jobs.generated_at;
		data.value = jobs;
	} else {
		error.value = `An error has occured: ${response.status} - ${response.statusText}`;
	}
}
onMounted(() => {
	fetchJobs();
});
</script>
